var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgZapier = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#zapier_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF4A00",
  d: "M32.015.03c1.797 0 3.595.153 5.3.459v18.656l13.19-13.19a31.7 31.7 0 0 1 4.082 3.45 34.6 34.6 0 0 1 3.473 4.091L44.87 26.687h18.673Q64 29.297 64 32c0 1.863-.152 3.634-.457 5.343H44.87l13.22 13.191a32 32 0 0 1-3.442 4.092 31.7 31.7 0 0 1-4.082 3.45l-13.22-13.19v18.656a38 38 0 0 1-5.3.458h-.061a30.6 30.6 0 0 1-5.3-.458V44.886l-13.19 13.19a32.2 32.2 0 0 1-7.555-7.542l13.19-13.19H.457A31 31 0 0 1 0 32.03v-.092c0-.458.03-1.038.091-1.649v-.183c.153-1.68.366-3.42.366-3.42H19.13L5.91 13.466C6.945 12 8.103 10.656 9.352 9.374s2.62-2.412 4.082-3.45l13.19 13.19V.459a38 38 0 0 1 5.3-.458h.03zm0 23.97h-.03c-2.376 0-4.66.427-6.763 1.221a19.1 19.1 0 0 0-1.218 6.749c0 2.412.426 4.671 1.218 6.778a19.1 19.1 0 0 0 6.763 1.221h.03c2.376 0 4.66-.427 6.763-1.22A19.1 19.1 0 0 0 39.996 32a19.1 19.1 0 0 0-1.218-6.779A19.1 19.1 0 0 0 32.015 24"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "zapier_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h64v64H0z"
})))));
export default SvgZapier;